import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import axios from 'axios';
import { splunkApi1 } from '../../../utils/Api';

// Dummy metrics


const Path1Splunk = () => {
  const [confluentRawIndex, setConfluentRawIndex] = useState(null);
  const [confluentFilteredIndex, setConfluentFilteredIndex] = useState(null);

  useEffect(() => {
    // Fetch real data from Splunk API using axios
    const fetchData = async () => {
      try {
        const response = await axios.get(splunkApi1, {});
         const found = response.data.entry.find(e => e.name === 'confluent_1_index_raw');
        setConfluentRawIndex(found || null);
        const filtered = response.data.entry.find(e => e.name === 'confluent_1_index');
        setConfluentFilteredIndex(filtered || null);
      } catch (error) {
        console.error('Error fetching data from Splunk API:', error);
      }
    };
    fetchData();
  }, []);


  const metrics = [
    { label: 'Storage Size', value: confluentRawIndex ? ((Number(confluentRawIndex.content?.currentDBSizeMB) || 0)/1024).toFixed(2) +' GB' : 'N/A', color: '#00b4a0' },
    { label: 'No. of Events', value: confluentRawIndex ? (confluentRawIndex.content?.totalEventCount || 0) : 0, color: '#1e90ff' }
  ];

  return (
    <>
        <Grid item xs={12} md={5}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#60a5fa' }}>
            Legacy Path Metrics Splunk
          </Typography>
          <Grid container spacing={1.5} sx={{ mb: 1.5, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 2, p: 2 }}>
            {metrics.map((m, i) => (
              <Grid item xs={6} key={m.label}>
                <Card sx={{ background: 'rgba(10,34,64,0.85)', borderRadius: 3, boxShadow: 3, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CardContent sx={{ textAlign: 'center', width: '100%', p: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ color: m.color, fontWeight: 700 }}>{m.label}</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 900, mt: 1, color: 'white' }}>{m.value}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          
          
        </Grid>
    </>
  )
}

export default Path1Splunk